import { optimizerTranslationsEnglish } from '@/modules/optimizer/translations/en';
import { ResourceLanguage } from 'i18next';

export const enTranslations: ResourceLanguage = {
  translation: {
    ...optimizerTranslationsEnglish,
  },
};
